import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function ClubInfoForm({ pendingclub, reviewPendingClub,   changeView }) {
  const { user } = useAuthContext();
  const navi = useNavigate();
  //Club Properies
  const [name, setName] = useState(pendingclub.name || "");
  const [subtitle, setSubtitle] = useState(pendingclub.subtitle || "");
  const [email, setEmail] = useState(pendingclub.email || "");
  const [phoneNumber, setPhoneNumber] = useState(pendingclub.phoneNumber || "");
  const [website, setWebsite] = useState(pendingclub.website || "");
  const [address, setAddress] = useState(pendingclub.address || "");
  const [city, setCity] = useState(pendingclub.city || "");
  const [county, setCounty] = useState(pendingclub.county || "");
  const [postCode, setPostCode] = useState(pendingclub.postCode || "");
  const [description, setDescription] = useState(pendingclub.description || "");
  const [facebook, setFaceBook] = useState(pendingclub.facebook || "");
  const [twitter, setTwitter] = useState(pendingclub.twitter || "");
  const [instagram, setInstagram] = useState(pendingclub.instagram || "");
  const [linkedin, setLinkedin] = useState(pendingclub.linkedin || "");
  const [tiktok, setTiktok] = useState(pendingclub.tikTok || "");

  const [isLoading, setIsLoading] = useState(false);

  //errors
  const [nameErr, setNameErr] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneNumberErr, setPhoneNumberErr] = useState("");
  const [websiteErr, setWebsiteErr] = useState("");
  const [addressErr, setAddressErr] = useState("");
  const [cityErr, setCityErr] = useState("");
  const [countyErr, setCountyErr] = useState("");
  const [postCodeErr, setPostCodeErr] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");

  //function states
  const [createErr, setCreateErr] = useState("");

  const regex = /^[A-Za-z0-9 ]*$/; // Allows letters, numbers, and spaces
const containsLetter = /[a-zA-Z]/;
  //

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const enableEditResponse = await axios.put(
        `${ApiConnectionString}/api/pendingClub/EnableEdit?ClubDetailsEnableEdit=true`,
        null,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      if (enableEditResponse.status == 200) {
        reviewPendingClub();
      }
    } catch (error) {
      console.error("An error occurred while enabling edit:", error);
      // You can handle the error here, e.g., show a notification to the user
    } finally {
      setIsLoading(false); // This will run regardless of success or failure
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let error = false;

    // Name Validations
 if (!regex.test(name) || !containsLetter.test(name)) {
  error = true;
  setNameErr("Name must contain at least one letter and can only include letters, numbers, and spaces.");
}
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    //Email validation
    if (email) {
      if (email.length > 300) {
        error = true;
        setEmailErr("Email is too long");
      }
    }
    if (phoneNumber) {
      if (phoneNumber.length > 300) {
        error = true;
        setPhoneNumberErr("Phone number is too long");
      }
    }
    if (website) {
      if (website.length > 300) {
        error = true;
        setWebsiteErr("Phone number is too long");
      }
    }
    if (address) {
      if (city.address > 300) {
        error = true;
        setAddressErr("City is too long");
      }
    }
    if (city) {
      if (city.length > 300) {
        error = true;
        setCityErr("City is too long");
      }
    }
    if (county) {
      if (county.length > 300) {
        error = true;
        setCountyErr("County is too long");
      }
    }
    if (postCode) {
      if (postCode.length > 50) {
        error = true;
        setPostCodeErr("Postcode is too long");
      }
    }
    if (description.length > 10000) {
      error = true;
      setDescriptionErr("description is too long");
    }

    if (!error) {
      const clubDetails = {
        name,
        email,
        phoneNumber,
        website,
        address,
        city,
        county,
        postCode,
        description,
        facebook,
        twitter,
        instagram,
        linkedin,
        tiktok,
        subtitle,
      };

      try {
        const updateClubDetailsResponse = await axios.put(
          `${ApiConnectionString}/api/pendingClub/ClubDetails`,
          clubDetails,
          {
            headers: { Authorization: `bearer ${user.token}` },
          }
        );

        if (updateClubDetailsResponse.status == 200) {
          reviewPendingClub();
          // Handle success here, e.g., show a success message or redirect
        }
      } catch (error) {
        if (error.response.data == "Club name already exists") {
          setNameErr("Club name already exists");
        }
        if(error.response.data == "Invalid postcode"){
          setPostCodeErr("Invalid postcode")
        }

        console.error("Error updating club details:", error);
      } finally {
        setIsLoading(false); // Stop loading after the operation
      }
    } else {
      setIsLoading(false); // Stop loading if validation fails
    }
  };

  if(isLoading){
    return(<div>
      <LoadingSpinner />
    </div>)
  }else{

  if (pendingclub.detailsSubmitted) {
    return (
<div className="container my-4">
  <div className="card shadow">
   
    <div className="card-body">
      <h5 className="border-bottom pb-2">Main Info</h5>
      <div className="row mb-3">
        <div className="col-md-6"><strong>Name:</strong> {name}</div>
        <div className="col-md-6"><strong>Subtitle:</strong> {subtitle}</div>
        <div className="col-md-6"><strong>Description:</strong> {description}</div>
        <div className="col-md-6"><strong>Website:</strong> {website}</div>
        <div className="col-md-6"><strong>Phone Number:</strong> {phoneNumber}</div>
        <div className="col-md-6"><strong>Email:</strong> {email}</div>
      </div>

      <h5 className="border-bottom pb-2">Address</h5>
      <div className="row mb-3">
        <div className="col-md-6"><strong>Address:</strong> {address}</div>
        <div className="col-md-6"><strong>City or Town:</strong> {city}</div>
        <div className="col-md-6"><strong>County:</strong> {county}</div>
        <div className="col-md-6"><strong>Post Code:</strong> {postCode}</div>
      </div>

      <h5 className="border-bottom pb-2">Social Media</h5>
      <div className="row mb-3">
        <div className="col-md-4"><strong>Facebook:</strong> {facebook}</div>
        <div className="col-md-4"><strong>Twitter:</strong> {twitter}</div>
        <div className="col-md-4"><strong>Instagram:</strong> {instagram}</div>
        <div className="col-md-4"><strong>Linkedin:</strong> {linkedin}</div>
        <div className="col-md-4"><strong>TikTok:</strong> {tiktok}</div>
      </div>

      <div className="mt-4 d-flex justify-content-between">
        <button className="pointer cancelButton fw-bold" onClick={handleEdit}>Edit</button>
        <button className="blue-button" onClick={() => changeView("clubImages")}>Continue</button>
      </div>
    </div>
  </div>
</div>

    );
  } else {
    return (
<div className="container my-4">
  {isLoading && <LoadingSpinner />}
  <form onSubmit={handleSubmit}>
    <div className="card shadow">
  
      <div className="card-body">

        {/* Main Info Section */}
        <h5 className="border-bottom pb-2">Main Info</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Name</label>
            <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} maxLength={100} required />
            {nameErr && <div className="text-danger">{nameErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Subtitle</label>
            <input className="form-control" value={subtitle} onChange={(e) => setSubtitle(e.target.value)} maxLength={120} required />
            <small className="text-muted">For example "Fitness and fun"</small>
          </div>
          <div className="col-12 mb-3">
            <label className="form-label fw-bold">Description</label>
            <textarea className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} rows={3} maxLength={10000} />
            {descriptionErr && <div className="text-danger">{descriptionErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Website</label>
            <input className="form-control" value={website} onChange={(e) => setWebsite(e.target.value)} />
            <small className="text-muted">Leave this field blank if you prefer not to display this publicly.</small>
            {websiteErr && <div className="text-danger">{websiteErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Phone Number</label>
            <input className="form-control" type="tel" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
            <small className="text-muted">Leave this field blank if you prefer not to display this publicly.</small>
            {phoneNumberErr && <div className="text-danger">{phoneNumberErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Email</label>
            <input className="form-control" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <small className="text-muted">Leave this field blank if you prefer not to display this publicly.</small>
            {emailErr && <div className="text-danger">{emailErr}</div>}
          </div>
        </div>

        {/* Address Section */}
        <h5 className="border-bottom pt-3 pb-2">Address</h5>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">City or Town</label>
            <input className="form-control" required value={city} onChange={(e) => setCity(e.target.value)} />
            {cityErr && <div className="text-danger">{cityErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Address</label>
            <textarea className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} rows={3} />
            {addressErr && <div className="text-danger">{addressErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">County</label>
            <input className="form-control" required value={county} onChange={(e) => setCounty(e.target.value)} />
            {countyErr && <div className="text-danger">{countyErr}</div>}
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Post Code</label>
            <input className="form-control" value={postCode} onChange={(e) => setPostCode(e.target.value)} />
            {postCodeErr && <div className="text-danger">{postCodeErr}</div>}
          </div>
        </div>

        {/* Social Media Section */}
        <h5 className="border-bottom pt-3 pb-2">Social Media</h5>
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Facebook</label>
            <input className="form-control" value={facebook} onChange={(e) => setFaceBook(e.target.value)} />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Twitter</label>
            <input className="form-control" value={twitter} onChange={(e) => setTwitter(e.target.value)} />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">Instagram</label>
            <input className="form-control" value={instagram} onChange={(e) => setInstagram(e.target.value)} />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">LinkedIn</label>
            <input className="form-control" value={linkedin} onChange={(e) => setLinkedin(e.target.value)} />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold">TikTok</label>
            <input className="form-control" value={tiktok} onChange={(e) => setTiktok(e.target.value)} />
          </div>
        </div>

        {/* Submit */}
        <div className="text-center pt-3">
          <button className="saveChanges-button">Submit</button>
        </div>

      </div>
    </div>
  </form>
</div>

    );
  }
}
}